import moment from 'moment';
import {DATE_FORMAT, DATE_TIME_FORMAT} from '../constants';

export const EST = 'America/New_York';

export const formatDateTime = (date: any, tz?:string) => {
    const newDate = moment.utc(date);
    if(tz) newDate.tz(tz);
    return newDate.format(DATE_TIME_FORMAT) + (tz === EST? ' EST' : '');
}
export const formatDate = (date: any, tz?:string) => {
    const newDate = moment.utc(date);
    if(tz) newDate.tz(tz);
    return newDate.format(DATE_FORMAT) + (tz === EST? ' EST' : '');
}


export const formatGraphQlDate = (date?: any) => date && date !== '' && date !== 'Invalid date' ? moment.utc(date).format('YYYY-MM-DD') : undefined;
export const formatGraphQlDateTime = (date?: any) => date && date !== '' && date !== 'Invalid date' ? moment.utc(date).format('YYYY-MM-DD HH:mm:ss') : undefined;
export const formatMoney = (amount: number, showCents?:boolean): string => '$' + amount.toFixed(showCents ? 2 : 0);